






















import { defineComponent, PropType } from '@vue/composition-api';

export default defineComponent({
  props: {
    tabNo: {
      type: Number as PropType<number>,
      required: true
    },
  },
  setup(props, context){

    const toTeacherList = () => {
      context.root.$router.push(`/teacher_site/teacher_list`);
    };

    const toUserViewableResultRangeList = () => {
      context.root.$router.push(`/teacher_site/uesr_result_viewable_range_list`);
    };

    const toUserScorableRangeList = () => {
      context.root.$router.push(`/teacher_site/uesr_scorable_range_list`);
    };

    const toUpload = () => {
      
      if(props.tabNo == 1){
        context.root.$router.push(`/teacher_site/teacher_upload`);
      }else if(props.tabNo == 2){
        context.root.$router.push(`/teacher_site/uesr_result_viewable_range_upload`);
      }else if(props.tabNo == 3){
        context.root.$router.push(`/teacher_site/uesr_scorable_range_upload`);
      }
    };

    return {
      toTeacherList,
      toUserViewableResultRangeList,
      toUserScorableRangeList,
      toUpload,
    };
  }
})
